import type { FaireProductEntity } from "../../entity_types/product";

export const p_m6kaybdq57: FaireProductEntity = {
  token: "p_m6kaybdq57",
  type: "product",
  name: "NONI - Thong Mule, Dangly Gold Hoop Detail",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/ce636d53f6a8d0f9498658c488054431949929564ff251fc9415da8a00b0dadd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/50d3d6377906ab588d5327b95de2c0238c86333b52f6f6d228524c3ccf2a6adc.jpeg",
    "https://cdn.faire.com/fastly/34b7efff8a949198462741bd4660f90b7fc5bd16524b115dd7dde0719eeb65ca.jpeg",
  ],
  priceDollars: 13,
  description:
    "A statement heel made for going out, this thong sandal features a sleek stiletto heel and playful gold disc charms that add just the right amount of movement and shine. Available in classic black and a nude clear finish for two effortlessly glam looks.\n\nOOTD\nStyle them with a slinky mini dress and a gold clutch for a night out, or pair with wide-leg trousers and a fitted top for something a little more elevated. Add chunky gold jewelry to play off the charm detailing.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:10.002Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
